import React, { useMemo } from 'react';
import { APITypes } from '../../../../../../../primary-record-types';
import { Form } from '../../../../../../v2BaseComponents/Form';
import { handleFormikSubmit } from '../../../../../../../utils/handleFormikSubmit';
import GroupFields from '../../../../../../shared/Groups/GroupFields';
import SideDrawerFormContainer, {
    ConfirmDirtyStateFormCloseContainer,
    SideDrawerDirtyFormExitValidationTracker,
} from '../../../../../../v2BaseComponents/Form/SideDrawerFormContainer';

export type EditGroupFormOwnProps = {
    group: APITypes.organizationService.OrganizationGroupDetails;
    onUpdate: (group: APITypes.organizationService.UpdateOrganizationGroupRequest) => void;
    isDisabled: boolean;
    onCancel: () => void;
};

export type EditGroupFormProps = EditGroupFormOwnProps;

const EditGroupForm: React.FC<EditGroupFormProps> = (props) => {
    const initialValues = useMemo<APITypes.organizationService.UpdateOrganizationGroupRequest>(
        () => ({
            name: props.group.metadata.name,
            description: props.group.metadata.description || '',
            address1: props.group.contactDetails.address1,
            address2: props.group.contactDetails.address2,
            city: props.group.contactDetails.city,
            state: props.group.contactDetails.state,
            zipCode: props.group.contactDetails.zipCode,
        }),
        [props.group],
    );

    return (
        <ConfirmDirtyStateFormCloseContainer>
            <Form
                initialValues={initialValues}
                onSubmit={(values, helpers) => {
                    props.onUpdate(values);
                    handleFormikSubmit(values, helpers);
                }}
                isDisabled={props.isDisabled}
                onCancel={props.onCancel}
                fillContainer
                forceStackFields
            >
                {({ isSubmitting, handleSubmit }) => (
                    <SideDrawerFormContainer
                        isDisabled={props.isDisabled || isSubmitting}
                        onSubmit={handleSubmit}
                        onCancel={props.onCancel}
                    >
                        <SideDrawerDirtyFormExitValidationTracker />
                        <GroupFields isDisabled={props.isDisabled} />
                    </SideDrawerFormContainer>
                )}
            </Form>
        </ConfirmDirtyStateFormCloseContainer>
    );
};

export default React.memo(EditGroupForm);
